import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

/**
 * AddDropdown: MUI IconButton with a dropdown menu containing
 * "Add Bookmark" and "Add Category" actions.
 *
 * Requirements: 14.1, 14.2, 14.3, 14.4, 14.6
 */

interface AddDropdownProps {
  onAddBookmark: () => void;
  onAddCategory: () => void;
  disabled?: boolean;
}

const AddDropdown: React.FC<AddDropdownProps> = ({
  onAddBookmark,
  onAddCategory,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddBookmark = () => {
    handleClose();
    onAddBookmark();
  };

  const handleAddCategory = () => {
    handleClose();
    onAddCategory();
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        disabled={disabled}
        aria-label="Add"
        aria-controls={open ? 'add-dropdown-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <AddIcon />
        <ArrowDropDownIcon sx={{ fontSize: 16, ml: -0.5 }} />
      </IconButton>

      <Menu
        id="add-dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={handleAddBookmark}>
          <ListItemIcon>
            <BookmarkAddIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add Bookmark</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleAddCategory}>
          <ListItemIcon>
            <CreateNewFolderIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add Category</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default AddDropdown;
